module.exports = __webpack_public_path__ + "static/media/willkins.3017e695.jpg";